'use client';

import React from 'react';
import { Box, Typography } from '@lucid/lego';
import { useStore } from '../../../store/store';
import VinSearch from '../../../components/VinSearch/VinSearch';

/**
 * LocateAsset component for searching and locating fleet vehicles.
 * Allows users to search by VIN, Name, Tel No., or License Plate.
 * Shows detailed vehicle information in a slider panel.
 *
 * @component
 * @returns {JSX.Element} Rendered locate asset page
 *
 * @example
 * <LocateAsset />
 */
const LocateAsset: React.FC = () => {
  const theme = useStore((state) => state.theme);

  return (
    <Box>
      <Box>
        <Typography variant="headline" size="small" color="primary-1" theme={theme}>
          Locate Asset
        </Typography>
        <Typography variant="body" size="medium" color="gray-3" theme={theme}>
          Search fleet of vehicles
        </Typography>
      </Box>

      <Box mt={24} pl={2} pr={2}>
        <VinSearch
          theme={theme}
          label=""
          placeholder="Search: VIN / Name / Tel No. / Licence Plate"
          emptyMessage="No vehicles found matching your search"
          dataTestId="locate-asset-search"
          sliderTitle="Vehicle Details"
        />
      </Box>
    </Box>
  );
};

export default LocateAsset;
